export const pageBuilderForMyCrm = (page) => {
  return {
    id: page.id,
    page_number: page.pageNumber,
    page_name: page.pageName,
    thumbnail_uri: page.thumbnailUri,
  };
};
